module.exports = __webpack_public_path__ + "static/media/flex.f16491ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/plans/images/flex.png
// module id = 1647
// module chunks = 0